import React from 'react';
import { LocalizedMessage } from 'intl/LocalizedComponents';
import PropTypes from 'prop-types';
import Select from 'components/core/Select';

const REASONS = [
  { value: 'BILLING_ERROR', label: 'refund_reason.billing_error' },
  { value: 'CANCELLATION', label: 'refund_reason.cancellation' },
  { value: 'EXCEPTIONAL_CASE', label: 'refund_reason.exceptional_case' },
  { value: 'GOODWILL_GESTURE', label: 'refund_reason.goodwill_gesture' },
  { value: 'TECHNICAL_ISSUE', label: 'refund_reason.technical_issue' },
  { value: 'UNAVAILABLE_SPACE', label: 'refund_reason.unavailable_space' },
];

class OnDemandRefundAll extends React.Component {
  constructor(props) {
    super(props);

    this.handleValidate = this.handleValidate.bind(this);

    this.state = {
      reason: null,
      errorMessageId: null,
    };
  }

  componentDidMount() {
    // We need to pass component reference to parent (= DialogItem)
    const { onRef } = this.props;
    onRef(this);
  }

  // Handlers called by parent (= DialogItem)
  handleValidate = () => {
    const {
      onValidate,
    } = this.props;
    const { reason } = this.state;

    if (reason) {
      onValidate({ reason: this.state.reason });
      return true;
    }

    if (!reason) {
      this.setState({ errorMessageId: 'error.onDemand.refundReasonRequired' });
      return false;
    }
  };

  render() {
    const { reason, errorMessageId } = this.state;

    return (
      <div className="p-4">
        <LocalizedMessage id="description.onDemand.confirmRefundAll" />
        <div style={{ maxWidth: '300px' }}>
          <Select
            label={<LocalizedMessage id="field.selectRefundReason" />}
            value={reason}
            items={
            REASONS.map(({ value, label }) => ({
              key: value,
              value,
              label: <LocalizedMessage id={label} />,
            }))
          }
            errorText={errorMessageId ? <LocalizedMessage id={errorMessageId} /> : null}
            required
            onChange={(newReason) => this.setState({ reason: newReason })}
          />
        </div>
      </div>
    );
  }
}
OnDemandRefundAll.propTypes = {
  onRef: PropTypes.func.isRequired,
  onValidate: PropTypes.func.isRequired,
};

module.exports = OnDemandRefundAll;



// WEBPACK FOOTER //
// ./routes/cpm/routes/carparks/assets/onDemand/OnDemandRefundAll.js